export default __webpack_public_path__ + "static/media/security.aa476282.svg";